import React, { useEffect, useState } from "react";
import { BarTask } from "../../types/bar-task";
import { GanttContentMoveAction } from "../../types/gantt-task-actions";
import { Bar } from "./bar/bar";
import { BarSmall } from "./bar/bar-small";
import { Milestone } from "./milestone/milestone";
import { Project } from "./project/project";
// import style from "./task-list.module.css";

export type TaskItemProps = {
  task: BarTask;
  arrowIndent: number;
  taskHeight: number;
  isProgressChangeable: boolean;
  isDateChangeable: boolean;
  isDelete: boolean;
  isSelected: boolean;
  rtl: boolean;
  type?: string;
  onEventStart: (
    action: GanttContentMoveAction,
    selectedTask: BarTask,
    event?: React.MouseEvent | React.KeyboardEvent,
    type?: string
  ) => any;
};

export const TaskItem: React.FC<TaskItemProps> = props => {
  const {
    task,
    // arrowIndent,
    isDelete,
    // taskHeight,
    isSelected,
    // rtl,
    onEventStart,
  } = {
    ...props,
  };
  // const textRef = useRef<SVGTextElement>(null);
  const [taskItem, setTaskItem] = useState<JSX.Element[]>([<div />]);
  // const [isTextInside, setIsTextInside] = useState(true);

  useEffect(() => {
    switch (task.typeInternal) {
      case "milestone":
        if (task.x1 >= 0 && task.actualx1 >= 0)
          setTaskItem([<Milestone {...props} />]);
        else setTaskItem([]);
        break;
      case "project":
        if (
          task?.x1 >= 0 &&
          task?.x2 >= 0 &&
          task.x2 > task.x1 &&
          task?.actualx1 >= 0 &&
          task?.actualx2 >= 0 &&
          task.actualx2 > task.actualx1
        )
          setTaskItem([<Project {...props} />]);
        else setTaskItem([]);
        break;
      case "smalltask":
        setTaskItem([<BarSmall {...props} />]);
        break;
      default:
        {
          let taskItem = [];
          if (task?.x1 >= 0 && task?.x2 >= 0) {
            taskItem.push(<Bar {...props} type={"planned"} />);
          }
          if (task?.actualx1 >= 0 && task?.actualx2 >= 0) {
            taskItem.push(<Bar {...props} type={"actual"} />);
          }
          setTaskItem(taskItem);
        }
        break;
    }
  }, [task, isSelected]);

  // useEffect(() => {
  //   if (textRef.current) {
  //     setIsTextInside(textRef.current.getBBox().width < task.x2 - task.x1);
  //   }
  // }, [textRef, task]);

  // const getX = () => {
  //   const width = task.x2 - task.x1;
  //   const hasChild = task.barChildren.length > 0;
  //   if (isTextInside) {
  //     return task.x1 + width * 0.5;
  //   }
  //   if (rtl && textRef.current) {
  //     return (
  //       task.x1 -
  //       textRef.current.getBBox().width -
  //       arrowIndent * +hasChild -
  //       arrowIndent * 0.2
  //     );
  //   } else {
  //     return task.x1 + width + arrowIndent * +hasChild + arrowIndent * 0.2;
  //   }
  // };

  return (
    <g>
      <g
        onKeyDown={e => {
          switch (e.key) {
            case "Delete": {
              if (isDelete) onEventStart("delete", task, e, "planned");
              break;
            }
          }
          e.stopPropagation();
        }}
        onMouseEnter={e => {
          onEventStart("mouseenter", task, e, "planned");
        }}
        onMouseLeave={e => {
          onEventStart("mouseleave", task, e, "planned");
        }}
        onDoubleClick={e => {
          onEventStart("dblclick", task, e, "planned");
        }}
        onClick={e => {
          onEventStart("click", task, e, "planned");
        }}
        // onFocus={() => {
        //   onEventStart("select", task);
        // }}
      >
        {taskItem[0]}
      </g>
      <g
        onKeyDown={e => {
          switch (e.key) {
            case "Delete": {
              if (isDelete) onEventStart("delete", task, e, "actual");
              break;
            }
          }
          e.stopPropagation();
        }}
        onMouseEnter={e => {
          onEventStart("mouseenter", task, e, "actual");
        }}
        onMouseLeave={e => {
          onEventStart("mouseleave", task, e, "actual");
        }}
        onDoubleClick={e => {
          onEventStart("dblclick", task, e, "actual");
        }}
        onClick={e => {
          onEventStart("click", task, e, "actual");
        }}
        // onFocus={() => {
        //   onEventStart("select", task);
        // }}
      >
        {taskItem[1]}
      </g>
    </g>
  );
};
